import { polygon } from 'viem/chains';
import { Config } from './config.interface';

export const productionConfig: Config = {
  environment: 'production',
  smartWalletEnabled: true,
  contracts: {
    usdt: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    phnm: '0x35d4F6D876d6c14775DF8A74b8dE3A699cF458AC',
    tables: '0xC10e197E783394D08310F5013F05362a64a891C4',
    redemption: '0x1D26bA1e70F19bd1FBdE67B38194e49f910f5f02',
    redemptionVault: '0x937b54FD8952A1226CA06591f2b5723A946f3079',
    leaderboard: '0x8a2bfd90EeD3027014b8AAc0A1555aDd3773D0BF',
  },
  chain: polygon,
  blockExplorerUrl: 'https://polygonscan.com/',
  usdtDecimals: 6,
  phnmDecimals: 18,
  postHostApiKey: 'phc_WR9OCd9XpGSuUYK0byJM8Ujianct37Jz7w02sZAsTHD',
  ethereumRpcUrl: 'https://twilight-frosty-dinghy.quiknode.pro/4ffcfdf0821bfb32db1339b4a0cf59ff038a7636',
  polygonRpcUrl: 'https://side-damp-spree.matic.quiknode.pro/787fca9d6bc053f7aacff150f391ef28b3677666',
};
